import type { DocMigration } from "../docMigration";
import { deleteOrphanedEntitiesForDocEntityBase } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_73: DocMigration = {
  maxSchemaVersion: "0.0.73",
  description: "Ensure all orphaned room entities are removed",
  apply(json: any) {
    const roomIds = Object.keys(json.rooms);
    const roomEntities: any[] = ["roomLayouts", "annotation", "casework"];

    if (!roomIds.length) {
      return json;
    }

    roomEntities.forEach((entityField) => {
      json = deleteOrphanedEntitiesForDocEntityBase(json, entityField, roomIds);
    });

    return json;
  },
};

export default migration_0_0_73;
